/**
 * @generated SignedSource<<a9ca93272bb7117b3cc045f9e6b34b02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RssMaxAge = "ONE_DAY" | "ONE_MONTH" | "ONE_WEEK" | "%future added value";
export type RssMaxItemsPerEpisode = "FIVE" | "ONE" | "TEN" | "THREE" | "%future added value";
export type RssProcessingDelay = "INSTANT" | "ONE_DAY" | "ONE_HOUR" | "SIX_HOURS" | "TWO_DAYS" | "%future added value";
export type SourceType = "BING_NEWS" | "GOOGLE_NEWS" | "REDDIT" | "RSS" | "SERPER_NEWS" | "TWITTER" | "YOU_TUBE" | "%future added value";
export type TopicType = "NEWS" | "RSS" | "%future added value";
export type TopicVisibility = "PRIVATE" | "PUBLIC" | "UNLISTED" | "%future added value";
export type TtsEngine = "ELEVEN_LABS" | "POLLY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TopicForm_topic$data = {
  readonly applePodcastsUrl: string | null | undefined;
  readonly cronSchedule: string | null | undefined;
  readonly customHostName: string | null | undefined;
  readonly customHostPersonality: string | null | undefined;
  readonly id: string;
  readonly name: string;
  readonly rssSettings: {
    readonly maxAge: RssMaxAge;
    readonly maxItemsPerEpisode: RssMaxItemsPerEpisode;
    readonly processingDelay: RssProcessingDelay;
  } | null | undefined;
  readonly s3AnchorImagePath: string | null | undefined;
  readonly s3IntroPath: string | null | undefined;
  readonly s3OutroPath: string | null | undefined;
  readonly slug: string;
  readonly sources: ReadonlyArray<{
    readonly domainFilter: string | null | undefined;
    readonly identifier: string;
    readonly label: string | null | undefined;
    readonly sourceType: SourceType;
  }>;
  readonly spotifyUrl: string | null | undefined;
  readonly stylePrompt: string;
  readonly topicType: TopicType;
  readonly ttsEngine: TtsEngine;
  readonly ttsModel: string | null | undefined;
  readonly visibility: TopicVisibility;
  readonly voiceId: string;
  readonly " $fragmentType": "TopicForm_topic";
};
export type TopicForm_topic$key = {
  readonly " $data"?: TopicForm_topic$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopicForm_topic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopicForm_topic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Source",
      "kind": "LinkedField",
      "name": "sources",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identifier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "domainFilter",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voiceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ttsEngine",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ttsModel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stylePrompt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customHostName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customHostPersonality",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topicType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RssSettings",
      "kind": "LinkedField",
      "name": "rssSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxItemsPerEpisode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxAge",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "processingDelay",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cronSchedule",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "s3IntroPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "s3OutroPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "s3AnchorImagePath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spotifyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "applePodcastsUrl",
      "storageKey": null
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "4bcbc8cb27730c7fa846ed0bd0d55e36";

export default node;
